import React, { useEffect, useState } from 'react';
import { Braces, Code2, Menu, X } from 'lucide-react';

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Solutions', href: '#work' },
    { name: 'Stack', href: '#expertise' },
    { name: 'Assembly', href: '#team' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 font-mono text-sm ${
        isScrolled
          ? 'bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-14 flex justify-between items-center">
        <a href="/" className="flex items-center gap-3 group">
          <div className="flex items-center justify-center w-8 h-8 rounded bg-gradient-to-br from-dotnet to-ts text-white shadow-md group-hover:shadow-dotnet/30 transition-all">
            <Code2 size={18} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-bold text-gray-900 tracking-tight">
              Ayum<span className="text-dotnet">.cs</span>
            </span>
            <span className="text-[10px] text-gray-500 group-hover:text-amber-500 transition-colors">
              v4.0.0-release
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="group flex flex-col items-center justify-center">
              <div className="flex items-center gap-1 text-gray-500 group-hover:text-black transition-colors">
                <span className="text-syntaxKeyword opacity-0 group-hover:opacity-100 transition-all -ml-4 group-hover:ml-0 font-bold">
                  {'{'}
                </span>
                <span className="group-hover:text-syntaxType transition-colors font-medium">{link.name}</span>
                <span className="text-syntaxKeyword opacity-0 group-hover:opacity-100 transition-all -mr-4 group-hover:mr-0 font-bold">
                  {'}'}
                </span>
              </div>
            </a>
          ))}

          <a
            href="#contact"
            className="ml-4 px-4 py-2 bg-dotnet hover:bg-dotnet/90 text-white rounded-sm font-medium flex items-center gap-2 transition-all shadow-md hover:shadow-dotnet/30"
          >
            <Braces size={14} />
            <span>new Project()</span>
          </a>
        </nav>

        <button
          className="md:hidden p-2 text-gray-600 hover:text-black"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-200 p-6 shadow-xl">
          <div className="flex flex-col gap-4 font-mono">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-lg text-gray-600 hover:text-black flex items-center gap-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <span className="text-syntaxKeyword font-bold">import</span>
                <span className="text-syntaxVariable">{link.name}</span>
              </a>
            ))}
            <a
              href="#contact"
              className="mt-4 w-full py-3 bg-dotnet text-center text-white font-bold rounded-sm shadow-md"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              await Contact.Init()
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
